import { useCallback, useEffect, useState } from "react"
import { useIsMounted } from "./useIsMounted"
import { callApi } from '../api'
import { useAccessToken } from "./useAccessToken"
import { getConfig } from "../config"

const { apiOrigin } = getConfig()

export const useApiCallback = (endpoint, origin = apiOrigin) => {
  const [{ data, error, loading }, setApiResult] = useState({ })
  const isMounted = useIsMounted()
  const { accessToken, isAuthenticated } = useAccessToken()

  const call = useCallback(async endpoint => {
    if(data || loading || !accessToken || !isAuthenticated) {
      return
    }

    const apiResult = await callApi(endpoint, accessToken, origin)
    if(isMounted){
      setApiResult({
        ...apiResult
      })
    }
  }, [accessToken, data, isAuthenticated, isMounted, loading, origin])

  useEffect(() => {
    call(endpoint)
  }, [call, endpoint])

  return { call, data, error, loading }
}
